module.exports = __webpack_public_path__ + "img/logo.216da612.png";